import { jsx as o } from "react/jsx-runtime";
const t = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...r,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        d: "m6.938 2.59-3.62 3.62.449 1.673 3.482-3.482v10.062l1.5-.402V4.4l3.473 3.474.449-1.673-3.612-3.611-1.06-1.061-1.061 1.06Z"
      }
    )
  }
);
export {
  t as ArrowUp
};
